import { IconType } from '@shared/enums/icon-type.enum';

type color = 'primary' | 'warn';
export class TabModel {
  id?: string = '';
  group?: string = '';
  label?: string = '';
  count?: number = null;
  showCount?: boolean = false;
  index?: number = 0;
  disabled?: boolean;
  pageIndex?: number = 1;
  type?: color = 'primary';
  tooltip?: string;
  icon?: string;
  iconSize?: 'sm' | 'md' | 'lg';
  iconType?: IconType;
}
